<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DepartmentListItem',
  props: {
    department: {
      type: Object,
      required: true,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    ...mapGetters('app', ['auth']),
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.department);
    },
  },
};
</script>

<template>
  <tr>
    <td>
      <router-link :to="`/department/show/${department.id}`">{{ department.name }}</router-link>
    </td>
    <td>
      <v-icon v-if="department.isDelete">done</v-icon>
      <v-icon v-else>close</v-icon>
    </td>
    <td width="80" align="right">
      <v-tooltip bottom>
        <v-btn v-if="auth.hasDeleteRights"
               @click.native="onDelete" flat icon slot="activator" :disabled="department.isDelete">
          <v-icon small>delete</v-icon>
        </v-btn>
        <span>Löschen</span>
      </v-tooltip>
    </td>
  </tr>
</template>
